export default "__VITE_ASSET__BKJRZJUD__"